// Initialize Map
$('.map-block').each(function () {
  let $mapID = $(this).attr('id');
  let map = L.map($mapID).setView([-41.29260796538415, 174.7768093624618], 5),
    markers = L.layerGroup().addTo(map);

  //Add tiles
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

  //Add markers
  $(this).on('initialize', function () {
    var maxLat, minLat, maxLng, minLng;
    //Clear old markers
    markers.clearLayers();

    $('.location-list .location').each(function () {
      if (!$(this).data('lat')) return;

      L.marker([$(this).data('lat'), $(this).data('long')])
        .bindPopup($(this).find('.popup-content').html())
        .addTo(markers);
      //Keep track of min/max lat/lng
      if (!maxLat || $(this).data('lat') > maxLat) maxLat = $(this).data('lat');
      if (!minLat || $(this).data('lat') < minLat) minLat = $(this).data('lat');
      if (!maxLng || $(this).data('long') > maxLng) maxLng = $(this).data('long');
      if (!minLng || $(this).data('long') < minLng) minLng = $(this).data('long');
    });

    let $southWest = L.latLng(minLat - 5, minLng - 5),
      $northEast = L.latLng(maxLat + 5, maxLng + 5);

    let $bounds = L.latLngBounds($southWest, $northEast);

    //Set bounding box
    map.setMaxBounds($bounds);
    map.setMinZoom(5);

    //Make sure it's not too zoomed in
    if (map.getZoom() > 13) map.setZoom(13);
  }).trigger('initialize');
})
